export default __webpack_public_path__ + "eee513b34cda9e7e64d322dc4cd721c7.svg";